import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import selectQaSectionsMap from 'redux/selectors/selectQASectionsMap'
import selectQaNodeMap from 'redux/selectors/selectQANodeMap'

const useTileUrl = (sectionId, getUrl) => {
  const qaSectionsMap = useSelector(selectQaSectionsMap)
  const qaNodeMap = useSelector(selectQaNodeMap)

  return useMemo(() => {
    try {
      const section = qaSectionsMap.get(sectionId)
      
      if (!section?.childSections) {
        return getUrl({ sectionId })
      }

      const activeChildNodes = section.childSections
        .map(id => qaNodeMap.get(id))
        .filter(node => node?.active)

      if (activeChildNodes.length === 1) {
        const onlyChild = activeChildNodes[0]
        return getUrl({ 
          sectionId, 
          expanded: onlyChild.id, 
          focusedId: onlyChild.id 
        })
      }

      return getUrl({ sectionId })
    } catch (error) {
      return getUrl({ sectionId })
    }
  }, [sectionId, qaSectionsMap, qaNodeMap, getUrl])
}

export default useTileUrl